import React from "react";
import "../styles/CompanyRibbon.css";

export default function CompanyRibbon() {
  const companies = [
    {
      name: "What Works Institute",
      logo: "/assets/C1.jpg",
      website: "https://www.whatworksinstitute.com",
    },
    {
      name: "Infacto Engineering",
      logo: "/assets/C2.jpg",
      website: "https://infacto.cz/en",
    },
    {
      name: "World Assembly of Professionals",
      logo: "/assets/C3.jpg",
      website: "https://www.linkedin.com/posts/iosh_gishw2025-visionzero-sustainability-activity-7352001983685226498-AMDF/",
    },
    {
      name: "Ostrava Technical Institute",
      logo: "/assets/C4.jpg",
      website: "https://www.vsb.cz/en",
    },
    // {
    //   name: "FN Immersive",
    //   logo: "/assets/C5.jpg",
    //   website: "",
    // },
  ];

  const loopCompanies = [...companies, ...companies];

  return (
    // HOMEPAGE SECTION 4
    <section
      id="strategic-collaboration"
      className="company-ribbon-section"
      aria-labelledby="company-ribbon-title"
    >
      <div className="company-ribbon-header">
        <p className="company-ribbon-kicker">
          Trusted Collaborations
        </p>

        <h2
          id="company-ribbon-title"
          className="company-ribbon-title"
        >
          Strategic Collaboration
        </h2>

        <p className="company-ribbon-description">
          Working with global research, engineering, education, and industry
          partners to strengthen safety knowledge, innovation, and practical
          implementation.
        </p>
      </div>

      <div
        className="company-ribbon"
        aria-label="Strategic collaborators"
      >
        <div className="company-track">
          {loopCompanies.map((company, index) => {
            const isDuplicate = index >= companies.length;

            const cardContent = (
              <>
                <div className="company-logo-wrapper">
                  <img
                    src={company.logo}
                    alt={isDuplicate ? "" : `${company.name} logo`}
                    loading="lazy"
                  />
                </div>

                <span className="company-name">
                  {company.name}
                </span>
              </>
            );

            return company.website ? (
              <a
                className="company-card company-link"
                href={company.website}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={
                  isDuplicate
                    ? undefined
                    : `Visit the ${company.name} website`
                }
                aria-hidden={isDuplicate ? "true" : undefined}
                tabIndex={isDuplicate ? -1 : 0}
                key={`${company.name}-${index}`}
              >
                {cardContent}
              </a>
            ) : (
              <div
                className="company-card"
                aria-hidden={isDuplicate ? "true" : undefined}
                key={`${company.name}-${index}`}
              >
                {cardContent}
              </div>
            );
          })}
        </div>
      </div>

      <p className="company-ribbon-note">
        Select a partner logo to visit its official website.
      </p>
    </section>
  );
}